import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, take, tap } from 'rxjs/operators';

import { AuthService } from '@main-client/src/app/auth/auth.service';
import { LocalStorageCheckerService } from '@main-client/src/app/core/local-storage-checker.service';

import type { Tenant } from '@libs/src/tenant/tenant.interface';
import type { IAppState } from '@main-client/src/app/app.state';

import isEmpty from 'lodash-es/isEmpty';

@Component({
  selector: 'app-login-view',
  templateUrl: './login-view.component.html',
})
export class LoginViewComponent implements OnInit {
  canLogIn = false;
  canSignup = false;
  tenant$ = this.store.select('tenant');

  tenant: Tenant;

  constructor(
    private readonly store: Store<IAppState>,
    private readonly localStorageChecker: LocalStorageCheckerService,
    private readonly route: ActivatedRoute,
    public readonly authService: AuthService,
  ) {}

  ngOnInit() {
    this.canLogIn = this.localStorageChecker.hasLocalStorage();
    this.canSignup =
      'false' !== this.route.snapshot.queryParamMap.get('signup');
    this.tenant$
      .pipe(
        filter((tenant) => !isEmpty(tenant)),
        tap((tenant) => {
          this.tenant = tenant;
        }),
        take(1),
      )
      .subscribe();
  }
}
